var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "files-list pt-4",
    },
    [
      _c(
        "pui-collapsible",
        {
          attrs: {
            expandable: false,
            configurable: "",
            headline: "Files",
          },
        },
        [
          [
            _c("input", {
              ref: "inputRef",
              attrs: {
                hidden: "",
                type: "file",
              },
              on: {
                change: _vm.onFileSelected,
              },
            }),
            _c(
              "pui-button",
              {
                attrs: {
                  slot: "collapsibleConfigurationContent",
                  icon: "add",
                  small: "",
                  disabled: _vm.isLoading,
                },
                on: {
                  click: _vm.onAddFileClicked,
                },
                slot: "collapsibleConfigurationContent",
              },
              [_vm._v(" Add File ")]
            ),
            _vm.isLoading
              ? _c("pui-loader-spinner", {
                  attrs: {
                    title: "Please wait!",
                  },
                })
              : _vm._e(),
            !_vm.isLoading
              ? _vm._l(_vm.fileList, function (file) {
                  return _c(
                    "div",
                    {
                      key: file.id,
                      staticClass: "files-list__item",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "files-list__item__title",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(file.name) +
                              _vm._s(file.extension) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "files-list__item__actions",
                        },
                        [
                          _c("pui-button", {
                            attrs: {
                              state: "secondary",
                              icon: "delete",
                              small: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onDeleteFileClicked(file.id)
                              },
                            },
                          }),
                          _c("pui-button", {
                            attrs: {
                              icon: "download",
                              small: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onDownloadFileClicked(
                                  file.id,
                                  `${file.name}${file.extension}`
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                })
              : _vm._e(),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }